export default "__VITE_ASSET__DMO6BJX7__"